<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Liste des utilisateurs</h1>
                <div class="pageOptions">
                    <btn text="Groupes" ico="groupeUser" @click="group" v-if="$store.getters.hasPerm('group:list')"></btn>
                    <btn text="Ajouter" ico="add" @click="add" v-if="$store.getters.hasPerm('user:add/edit')"></btn>
                </div>
            </div>
            <search-bar @search="search" :value="filter"></search-bar>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th>
                        Nom
                        <table-order name="lastname" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Prénom
                        <table-order name="firstname" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Nom d'utilisateur
                        <table-order name="login" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Droit
                        <table-order name="groups.label" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Options
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(user,key) in visibles">
                        <td>{{user.lastname}}</td>
                        <td>{{user.firstname}}</td>
                        <td>{{user.login}}</td>
                        <td>{{user.groups.label}}</td>
                        <td class="tableOptions">
                            <div @click="edit(user.id)" v-if="$store.getters.hasPerm('user:add/edit')" title="Modifier l'utilisateur">
                                <svg class="option"><use xlink:href="#icon-edit"></use></svg>
                            </div>
                            <label class="switch" v-if="$store.getters.hasPerm('user:active')" :title="(user.active == 0 ? 'Activer' : 'Désactiver') + ' l\'utilisateur' ">
                                <input type="checkbox" @change="active(user, $event)" :checked="user.active == 1">
                                <span class="slider"></span>
                            </label>
                        </td>
                    </tr>
                    <tr v-if="visibles.length <= 0">
                        <td colspan="5" style="text-align: center">Il n'y a aucun utilisateur</td>
                    </tr>
                </tbody>
            </table>
            <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange" @limitChange="limitChange"></pagination>
        </div>
    </div>

</template>

<script>
    import Btn from "@/components/Btn";
    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Loader from "@/components/Loader";
    export default {
        name: "Users",
        components: {Loader, SearchBar, Btn,Pagination, TableOrder},
        data(){
            return{
                limit:100,
                currentPage:0,

                users:[],
                filter:"",
                order:{
                    order:'asc',
                    name:'lastname'
                },

                locals : ["currentPage","users","filter","order"],
                cookies : ["limit"],
            }
        },
        methods: {
            load(){
                axios.get(tools.api("users"),tools.headerGET())
                    .then((response) => {
                        this.users = response.data;

                        tools.loader(false);
                        tools.saveLocals("users", this);
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            add(){
                this.$router.push("user")
            },
            edit(userId){
                this.$router.push("user/"+userId)
            },
            active(user,$event){

                let active = $event.target.checked;

                axios.get(tools.api("user/"+user.id+"/toggle/"+(active?"1":"0")),tools.headerGET())
                    .then((response) => {
                        if(!tools.isSuccessResponse(response)){
                            $event.target.checked = false;
                            return tools.popup("valid",{
                                title : "Erreur",
                                message : "Erreur lors de l'activation/désactivation de l'utilisateur '"+user.login+"'",
                            });
                        }

                        tools.saveLocals("users", this);
                    })
                    .catch((error) => {
                        $event.target.checked = false;
                        tools.popup("valid",{
                            title : "Erreur",
                            message : "Erreur lors de l'activation/désactivation de l'utilisateur '"+user.login+"'. <br/><br/>Détail de l'erreur : <br/>"+tools.parseError(error)
                        })
                    })
            },
            group(){
                this.$router.push("/groups")
            },

            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("users", this);
            },
            pageChange(page) {
                this.currentPage = page;

                tools.saveLocals("users", this);
            },
            search(filter){
                this.filter = filter;

                tools.saveLocals("users", this);
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("users", this);
            }
        },
        computed:{
            filters(){

                let users = this.users;

                if(this.filter) {
                    let reg = new RegExp(this.filter, "i");
                    users = users.filter((user) => reg.exec(user.login) || reg.exec(user.firstname) || reg.exec(user.lastname))
                }

                tools.sortArray(users,this.order);

                return users;
            },
            visibles(){
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            }
        },
        mounted(){

            if(!this.$store.getters.hasPerm('user:list')){
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode",false);

            tools.setLocals("users", this);
            tools.setCookies("users", this);

            tools.$emit("orderChange",this.order);

            this.load();
        }
    }
</script>